module.exports = __webpack_public_path__ + "static/media/pn.55290b5e.svg";